import { useEffect, useState } from 'react';

const useTelegram = () => {
    const [webApp, setWebApp] = useState(null);

    useEffect(() => {
        const tg = window.Telegram?.WebApp;
        if (tg) {
            tg.ready();
            tg.expand();
            setWebApp(tg);
            tg.setBackgroundColor("#FFFFFF");
        }
    }, []);

    return {
        webApp,
        user: webApp?.initDataUnsafe?.user,
        queryId: webApp?.initDataUnsafe?.query_id,
        initData: webApp?.initData,
        initDataUnsafe: webApp?.initDataUnsafe,
        MainButton: webApp?.MainButton,
        BackButton: webApp?.BackButton,
        HapticFeedback: webApp?.HapticFeedback,
        isReady: !!webApp,
        platform: webApp?.platform,
        colorScheme: webApp?.colorScheme,
        themeParams: webApp?.themeParams,
        isExpanded: webApp?.isExpanded,
        expand: () => webApp?.expand(),
        close: () => webApp?.close(),
        showAlert: (message, callback) => webApp?.showAlert(message, callback),
        showConfirm: (message, callback) => webApp?.showConfirm(message, callback),
        showPopup: (params, callback) => webApp?.showPopup(params, callback),
        enableClosingConfirmation: () => webApp?.enableClosingConfirmation(),
        disableClosingConfirmation: () => webApp?.disableClosingConfirmation(),
        onEvent: (eventType, eventHandler) => webApp?.onEvent(eventType, eventHandler),
        offEvent: (eventType, eventHandler) => webApp?.offEvent(eventType, eventHandler),
        sendData: (data) => webApp?.sendData(JSON.stringify(data)),
        openLink: (url) => webApp?.openLink(url),
        openTelegramLink: (url) => webApp?.openTelegramLink(url),
        openInvoice: (url, callback) => webApp?.openInvoice(url, callback),
        setHeaderColor: (color) => webApp?.setHeaderColor(color),
        setBackgroundColor: (color) => webApp?.setBackgroundColor(color),
    };
};

export default useTelegram;
